import base from './baseunit.module.scss'

const baseUnit = {
  spacing: Number(base.baseUnit),
  shape: {
    borderRadius: Number(base.borderRadius),
  },
  boxShadow: {
    primary: 'rgba(0, 0, 0, 0.10)',
    hint: 'rgba(0, 0, 0, 0.15)',
  },
  space: (val: number) => val * Number(base.baseUnit),
  size: (val: number) => val * Number(base.baseUnit),
  unit: (val: number) => val * 1,
  rem: (val: number) => `${val * 1}rem`,
  borderWeight: Number(base.borderWeight),
  fontWeight: {
    lighter: 300,
    normal: 400,
    medium: 500,
    bold: 700,
  },
  lineHeight: (val: number) => val * 1,
  gridContainerSpacing: base.gridContainerSpacing,
  gridLabelSpacing: (base.baseUnit * base.gridContainerSpacing) / 2,
}

export default baseUnit
